import React from 'react';
import './RadioGroup.scss';

interface RadioGroupProps<T> {
  label?: string;
  name: string;
  options: { label: string; value: T }[];
  value: T | null | undefined;
  onChange: (value: T) => void;
  required?: boolean;
  error?: string;
  orientation?: 'row' | 'column';
}

const RadioGroup = <T,>({
  label,
  name,
  options,
  value,
  onChange,
  required,
  error,
  orientation = 'row',
}: RadioGroupProps<T>) => {
  return (
    <div className="radio-group-container">
      {label && (
        <label>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div className={`radio-group-options radio-group-options--${orientation}`}>
        {options.map((opt, i) => (
          <label key={i} className="radio-group-option">
            <input
              type="radio"
              name={name}
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
            />
            {opt.label}
          </label>
        ))}
      </div>
      {error && <div className="radio-group-error">{error}</div>}
    </div>
  );
};

export default RadioGroup;
